const Layout = () => import('@/layout/index.vue')

export default {
    path: '/users',
    component: Layout,
    redirect: '/users/member',
    name: 'Users',
    meta: {
        title: '用户管理',
        icon: 'users',
        defaultOpened: true,
        auth: ['Users']
    },
    children: [
        // {
        //     path: 'agent',
        //     name: 'UsersAgent',
        //     component: () => import('@/views/users/agent/index.vue'),
        //     meta: {
        //         title: '代理管理',
        //         icon: 'users-agent'
        //     }
        // },
        {
            path: 'member',
            name: 'UsersMember',
            component: () => import('@/views/users/member/index.vue'),
            meta: {
                title: '用户列表',
                icon: 'users-member',
                auth: ['UsersMember']
            }
        },
        {
            path: 'qianchuan',
            name: 'UsersQianchuan',
            component: () => import('@/views/users/qianchuan/index.vue'),
            meta: {
                title: '千川账号',
                icon: 'users-qianchuan',
                auth: ['UsersQianChuan']
            }
        }
    ]
}
